import { Auth } from "aws-amplify";

export const logout = () => {
  return Auth.signOut();
};
